import toast from "react-hot-toast";

// Replacement for react-notifications-component Toast function
export const showToast = (
  title: string,
  message: string,
  type: "success" | "danger" | "info" | "default" | "warning"
) => {
  const fullMessage = title ? `${title}: ${message}` : message;

  switch (type) {
    case "success":
      toast.success(fullMessage);
      break;
    case "danger":
      toast.error(fullMessage);
      break;
    case "warning":
      toast(fullMessage, {
        icon: "⚠️",
        style: {
          background: "#ff8d72",
          color: "#fff"
        }
      });
      break;
    case "info":
      toast(fullMessage, {
        icon: "ℹ️"
      });
      break;
    default:
      toast(fullMessage);
  }
};

// Replacement for react-notification-alert notify function
export const notify = (message: string, type: "success" | "danger" | "info" | "primary" | "warning" = "success") => {
  const typeMap = {
    primary: "default" as const,
    danger: "danger" as const,
    success: "success" as const,
    warning: "warning" as const,
    info: "info" as const
  };

  showToast("", message, typeMap[type] || "default");
};

// Legacy compatibility wrapper
export const Toast = showToast;
